import React from 'react';
import { CheckCircleFilled, CloseOutlined } from '@ant-design/icons';
import Typography from 'style-guide/component/Typography';
import { FileListProps } from '../types/questionTypes';

const FileList: React.FC<FileListProps> = ({
  files,
  currentQuestion,
  onRemoveFile,
}) => {
  if (files.length === 0) return null;

  return (
    <div className="mt-4 mb-20">
      <Typography 
        text={`Files for Question ${currentQuestion + 1}:`} 
        variant="MD" 
      />
      <ul className="mt-2 space-y-2">
        {files.map((file) => (
          <div
            key={file.file_id}
            className="w-[376px] border-[1px] border-[#D9D9D9] flex flex-row items-center justify-between p-2 rounded-lg"
          >
            <div className="flex items-center gap-2">
              <CheckCircleFilled className="text-[green]" />
              <div className="flex flex-col">
                <Typography
                  text={file.display_name}
                  variant="LG"
                  className="text-black"
                />
              </div>
            </div>
            <CloseOutlined
              className="h-4 cursor-pointer text-[red]"
              onClick={() => onRemoveFile(file)}
              role="button"
            />
          </div>
        ))}
      </ul>
    </div>
  );
};

export default FileList;
